import React, {Component} from 'react';
import {Col, Form, FormGroup, Input, Label} from "reactstrap";
import Select from "../../local_node_modules/react-select";
import Datetime from "react-datetime";
import moment from "moment";
import DefaultModal from "../invoice/DefaultModal";
import {request} from "../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import Alert from "react-s-alert";
import {validateField} from "../../common/validation";
import {EntegratorIdentifiers} from "../../helper/enums";
import TextEditor from "../../components/TextEditor";

const forbiddenEntegrators = ["VEGA", "HIZLI", "MEDIFATURA", "TURKKEP"];

class TimelineModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timeline: undefined,
            timelineInfo: {},
            timelineDetail: [],
            btnDisabled: false,
            selectedList: [],
            error: {},
            subOptions: []
        };

        this.entegratorMap = Object.entries(EntegratorIdentifiers).reduce((acc, [key, value]) => {
            acc[value] = key;
            return acc;
        }, {});

        this.save = this.save.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onEntegratorChange = this.onEntegratorChange.bind(this);
    }

    componentDidMount() {
        let {mode, recordId} = this.props;
        if ((mode === "update" || mode === "view") && recordId) {
            let self = this;
            let params = {
                url: "/timeline/fetchTimelineByRecordId",
                method: 'post',
                data: recordId
            };

            request(params).then(function (response) {
                self.setState({timeline: response.data.timeline, timelineInfo: response.data});

                let temp = [];
                const myArray = Object.entries(EntegratorIdentifiers).map(entry => {
                    return {value: entry[1], label: entry[0]};
                });

                if (response.data.showOn && Array.isArray(response.data.showOn)) {
                    myArray.forEach(item => {
                        if (!forbiddenEntegrators.includes(item.label) && response.data.showOn.includes(item.value)) {
                            temp.push(item);
                        }
                    });
                }
                self.setState({selectedList: temp})
            }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            let timelineInfo = this.state.timelineInfo;
            this.setState({timelineInfo});
        }
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    save(e) {
        e.preventDefault();
        let {timelineInfo, selectedList} = this.state;
        let error = {};
        let messages = [];

        if (selectedList.length === 0 && timelineInfo.showOn) {
            const showOnArray = timelineInfo.showOn.split(",").map(id => {
                return {
                    value: id,
                    label: this.entegratorMap[id] || id
                };
            });
            selectedList = showOnArray.filter(item => !forbiddenEntegrators.includes(item.label));
            this.setState({selectedList});
        }

        if (!timelineInfo.title || timelineInfo.title.trim() === "") {
            error.title = {valid: false, message: "Başlık zorunludur."};
            messages.push("Başlığı doldurunuz.");
        }
        if (!timelineInfo.showAt) {
            error.showAt = {valid: false, message: "Yayınlanma tarihi zorunludur."};
            messages.push("Yayınlanma tarihini seçiniz.");
        }
        if (selectedList.length === 0) {
            error.showOn = {valid: false, message: "Gösterilecek entegratörler zorunludur."};
            messages.push("Gösterilecek entegratörleri seçiniz.");
        }
        if (!timelineInfo.description || timelineInfo.description.trim() === "") {
            error.description = {valid: false, message: "Açıklama zorunludur."};
            messages.push("Açıklamayı doldurunuz.");
        }

        if (messages.length > 0) {
            this.setState({error});
            Alert.error(messages.join(" "), {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
            return;
        }

        let data = deepCopyObject(timelineInfo);
        data.description = timelineInfo.description.trim();

        let params = {
            url: "/timeline/addTimeline",
            method: 'post',
            data: data
        };

        this.setState({btnDisabled: true});

        request(params)
            .then((response) => {
                this.setState({btnDisabled: false});
                Alert.success("Kayıt işlemi başarılı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
                this.props.listener(false, true);
            })
            .catch((error) => {
                this.setState({btnDisabled: false});
                showAxiosError(error);
            });
    }

    editHandleInputChange = (event) => {
        let name, value;

        if (event && event.target) {
            ({name, value} = event.target);
        } else {
            name = event.name;
            value = event.value;
        }

        let timelineInfo = deepCopyObject(this.state.timelineInfo);
        timelineInfo[name] = value;
        this.setState({timelineInfo});
    };

    changeDate = (momentObj, fieldName) => {
        let value;
        if (!(typeof momentObj === "string")) {
            value = momentObj.format("YYYY-MM-DD");
        } else {
            if (momentObj.length === 0) {
                value = undefined;
            }
            value = momentObj;
        }

        let timelineInfo = this.state.timelineInfo;
        timelineInfo.showAt = value;

        this.setState({timelineInfo});
    }

    onCancel() {
        this.props.listener(false, false);
    }

    onEntegratorChange(data) {
        let timelineInfo = deepCopyObject(this.state.timelineInfo);
        timelineInfo.showOn = data.map(item => item.value).join(",");
        this.setState({timelineInfo, selectedList: data});
    }

    entegratorList = () => {
        return Object.entries(EntegratorIdentifiers).map(entry => {
            return {value: entry[1], label: entry[0]};
        }).filter(item => !forbiddenEntegrators.includes(item.label));
    }

    render() {
        let {timelineInfo} = this.state;

        return (
            <DefaultModal
                isOpen={this.props.modal}
                disabled={this.state.btnDisabled}
                title={`${this.props.mode === "create" ? "Oluştur" : this.props.mode === "view" ? "Görüntüle" : "Düzenle"} `}
                size="lg"
                modalBodyStyle={{padding: "0"}}
                confirmBtnText={this.props.mode === "view" ? null : "Kaydet"}
                cancelBtnText={this.props.mode === "view" ? "Kapat" : "İptal"}
                onConfirm={(e) => this.save(e)}
                onCancel={this.onCancel}>
                <Form className="px-4">
                    <FormGroup row>
                        <Label sm={4}>Başlık</Label>
                        <Col sm={8} className={this.validateClass("title")}>
                            <Input
                                type="text"
                                name="title"
                                id="title"
                                value={timelineInfo.title || ''}
                                disabled={this.props.mode === "view"}
                                onChange={this.editHandleInputChange}
                                onBlur={this.validateField}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Yayınlanma Tarihi</Label>
                        <Col sm={8}>
                            <Datetime
                                locale="tr"
                                className="datepicker"
                                input={true}
                                inputProps={this.props.mode === "view" ? {
                                    id: 'showAt',
                                    disabled: true
                                } : {id: 'showAt'}}
                                closeOnSelect={true}
                                value={timelineInfo.showAt ? moment(timelineInfo.showAt) : ''}
                                dateFormat="DD-MM-YYYY"
                                timeFormat={false}
                                onChange={(e) => this.changeDate(e, "date")}
                                isValidDate={function (current) {
                                    return current.isSameOrAfter(Datetime.moment(), 'day');
                                }}
                            />

                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Açıklama</Label>
                        <Col sm={8} className={this.validateClass("content")}>
                            {this.props.mode !== "view" && (
                                <TextEditor
                                    name="description"
                                    mode={this.props.mode}
                                    listener={(name, value) => this.editHandleInputChange({name, value})}
                                    content={timelineInfo.description || ''}
                                    onBlur={this.validateField}
                                    updateMod="viewUpdate"
                                />
                            )}
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Gösterilecekler</Label>
                        <Col sm={8} className={this.validateClass("showOn")}>
                            <Select
                                className="select-control"
                                name="showOn"
                                id="showOn"
                                disabled={this.props.mode === "view"}
                                multi={true}
                                ref="tAlias"
                                placeholder="Entegrator Seçiniz..."
                                value={timelineInfo.showOn}
                                onChange={(e, value) => e && this.onEntegratorChange(e, value)}
                                options={this.entegratorList()}
                                onBlur={(e) => this.validateField(e)}
                            />
                        </Col>
                    </FormGroup>
                </Form>
            </DefaultModal>
        )
    }
}

export {TimelineModal};